import { getTranslateFn } from '@project44/translations-utils';

import { translations } from '../../../l10n/config';
import { PACKAGE_NAME } from '../../utils/constants/PACKAGE_NAME';
import { makeP44Styles } from '../../utils/theme';
import ErrorIcon from '../ErrorIcon';

const t = getTranslateFn(PACKAGE_NAME, translations);

const useStyles = makeP44Styles({
  container: {
    backgroundColor: '#E1E4EB',
    minHeight: '100%',
    paddingTop: 80,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    fontSize: 48,
    color: '#98A3B8',
  },
  title: {
    color: '#040815',
    fontSize: 20,
    fontWeight: 500,
    marginTop: 16,
    marginBottom: 8,
  },
  message: {
    color: '#040815',
    fontSize: 14,
    fontWeight: 400,
    marginTop: 0,
  },
});

interface ErrorPageProps {
  title?: string;
  message?: string;
}

const ErrorPage = (props: ErrorPageProps) => {
  const { title = t('errorPage.title'), message = t('errorPage.description') } =
    props;

  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <ErrorIcon className={classes.icon} />
        <h1 className={classes.title}>{title}</h1>
        <p className={classes.message}>{message}</p>
      </div>
    </div>
  );
};

export default ErrorPage;
